import { createRoot } from 'react-dom/client';
import { App } from './app/App';

export type T = 'a' | 'b' | 'c' | 'd' | 'e';

const root_id = '__root';

function getRoot() {
  const existing_el = document.getElementById(root_id);
  if (existing_el) {
    return existing_el;
  }

  const new_el = document.createElement('div');
  new_el.id = root_id;
  document.body.appendChild(new_el);
  return new_el;
}

function start() {
  const root_el = getRoot();
  const react_root = createRoot(root_el);
  react_root.render(<App />);
}

document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', start)
  : start();
